import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeading, PageSubHeading } from '@/typography/Typography';
import { ViewSwitch } from '@/components/shared/ViewSwitch';
import { EmailsTab } from './EmailsTab';
import { LegalDocumentsTab } from './LegalDocumentsTab';

export const InstaConfigPage = () => {
    const { t } = useTranslation();
    const [tabIndex, setTabIndex] = useState<number | null>(null);

    const viewSwitchItems = useMemo(() => {
        return [
            {
                primaryText: t('emails'),
                badgeText: '',
                route: 'emails',
                routeComponent: <EmailsTab />
            }
            // {
            //     primaryText: t('legal_documents'),
            //     badgeText: '',
            //     route: 'legal-documents',
            //     routeComponent: <LegalDocumentsTab />
            // }
        ];
    }, [t]);

    return (
        <div>
            <PageHeading>InstaConfig</PageHeading>
            <PageSubHeading>
                In this area its possible to adjust the standard settings for
                all customers
            </PageSubHeading>
            <ViewSwitch
                itemList={viewSwitchItems}
                setSelectedIndex={setTabIndex}
                selectedIndex={tabIndex}
            />
        </div>
    );
};

// Keep the old export name for backward compatibility
export const EmailsPage = InstaConfigPage;
